import { useSelector } from 'react-redux'
import { Table } from '../../../common/table'
import { formatVal } from '../../../helpers/value'
import { BOARD_COL_IDS } from '../constant'
import {
  selectCompanyBoardOfDirectorById,
  selectCompanyInfoDetail,
} from '../store/slice'

export const Director = ({ isDynamicReport }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const rowIds = useSelector(
    selectCompanyInfoDetail((detailData) => {
      const data = detailData.companyBoardOfDirector
      if (!data) return []
      return data.map((item) => item.personId)
    }),
  )

  return (
    <Table
      ids={rowIds}
      getDataFromRedux={selectCompanyBoardOfDirectorById}
      schema={Object.keys(BOARD_COL_IDS).map((key, index) => {
        const colId = BOARD_COL_IDS[key]
        const isSttCol = colId === BOARD_COL_IDS.STT
        return {
          colId,
          title: isSttCol ? '#' : 'companyProfile.' + key,
          isI18n: true,
          thStyle: {
            justifyContent:
              colId === BOARD_COL_IDS.SHAREHOLDING ? 'flex-end' : '',
          },
          tdStyle: {
            textAlign: colId === BOARD_COL_IDS.SHAREHOLDING ? 'right' : 'left',
          },
          render: (data, { rowIndex }) => {
            switch (colId) {
              case BOARD_COL_IDS.STT:
                return rowIndex + 1
              case BOARD_COL_IDS.SHAREHOLDING:
                return formatVal(data * 100, locale) + '%'
              default:
                return data
            }
          },
        }
      })}
      noDataText="companyProfile.NO_DIRECTOR_DATA"
      autoHeightMax={1000}
      isDynamicReport={isDynamicReport}
    />
  )
}
